/** @format */

import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular } from "assets/icons";

export const SlideToggleSwitch = ({ toggleState, setToggleState, checkBoxId, fromBtn, setFromBtn }) => {
    const handleSwitchToggled = (e) => {
        const targetNodeName = e.target.nodeName;
        // console.log("button: ",targetNodeName);
        const validNodes = ["label", "input", "i"];
        // check it's coming from toggle switch
        if (validNodes.includes(targetNodeName.toLowerCase())) {
            setToggleState(!toggleState);
        }
    };

    const handleEnter = (e) => {
        if (e.code === "Enter" || e.code === "Space") {
            e.preventDefault();
            setToggleState(!toggleState);
        }
    };
    return (
        <>
            <button onKeyDown={handleEnter}>
                <input
                    type="checkbox"
                    className="toggle"
                    onChange={handleSwitchToggled}
                    checked={toggleState}
                    id={checkBoxId}
                    tabIndex={-1}
                />
                <label htmlFor={checkBoxId} className={`${toggleState ? "toggle-on" : "toggle-off"}`}>
                    {toggleState ? <FontAwesomeIcon icon={solid.faEnvelope} transform="shrink-7" /> : <FontAwesomeIcon icon={regular.faEnvelope} transform="shrink-7" />}
                </label>
            </button>
             
              
        </>
    );
};
